// The API transports scale in percent — rendering needs the multiplier. The
// state/PUT keep the percent value untouched. Non-positive/missing values fall
// back to 1 (no zoom).
export const normalizeLayoutScale = (value: number | undefined): number => {
  if (typeof value !== 'number' || value <= 0) {
    return 1;
  }

  return value / 100;
};
